import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { NModalLayoutRight } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { StoreFinderComponent } from '../../../store/store-finder.component';
import { Product } from '../../product.decorator';
export const SEE_IN_STORE_MODAL_ID = 'seeInStoreModal';
@DfModal({
    id: SEE_IN_STORE_MODAL_ID,
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        modalClass: 'bg-col-w p-t-15 p-a-10 p-a-4-s p-t-7-s'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'product-view-see-in-store-modal',
    templateUrl: './product-view-see-in-store-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [StoreFinderComponent]
})
export class ProductViewSeeInStoreModalComponent {
    constructor(
    @Optional()
    private modalRef: ModalRef<ProductViewSeeInStoreModalComponent>,
    @Optional()
    @Inject(MODAL_DATA)
    public product: Product<IProductDataV3>) { }
    close() {
        this.modalRef.close();
    }
    scrollToTop(): void {
        this.modalRef.containerInstance.scrollToTop();
    }
}
